module.exports = __webpack_public_path__ + "bd882a30c42dfd6fa2cd8187f41abbc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/static/portrait-logo.jpg
// module id = 261
// module chunks = 0